var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CasProfileApi } from "@jti/rest-api";
export const getProfileEndpoint = (builder) => ({
    getProfile: builder.query({
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            const casProfileApi = CasProfileApi.init();
            const preparedProfileType = yield casProfileApi.getProfile();
            return {
                data: {
                    accountContact: {
                        firstname: preparedProfileType.personalInfo.firstname,
                        lastname: preparedProfileType.personalInfo.lastname,
                        telephone: preparedProfileType.personalInfo.telephone,
                        dob: preparedProfileType.personalInfo.dob,
                    },
                    isAgeVerified: preparedProfileType.is_age_verified,
                    consentPurposes: preparedProfileType.purposes,
                },
            };
        }),
        providesTags: ["Profile"],
    }),
});
//# sourceMappingURL=getProfile.endpoint.js.map